import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'

import { NetworkError, StatusError, JSONError } from '../../libs/enhancedFetch'
import Error from '../../ui/views/errors/Error'
import Connection from '../../assets/animations/connection'
import Person from '../../assets/animations/person'
import useTranslations from '../../i18n/useTranslations'

const CaughtError = ({ error }) => {
  const history = useHistory()
  const t = useTranslations()

  const reload = () => {
    window.location.reload()
  }

  const goBack = () => history.goBack()

  switch (error?.name) {
    case NetworkError.name:
      return (
        <Error
          title="error:connection:title"
          text="error:connection:text"
          image={<Connection />}
        >
          <Button sx={{ mb: 2 }} onClick={goBack}>
            {t('action:go-to-previous-page')}
          </Button>
          <Button sx={{ mb: 6 }} onClick={reload}>
            {t('action:reload-page')}
          </Button>
        </Error>
      )

    case StatusError.name:
    case JSONError.name:
      return (
        <Error
          title="error:server:title"
          text="error:server:text"
          image={<Person />}
        >
          <Button sx={{ mb: 2 }} onClick={goBack}>
            {t('action:go-to-previous-page')}
          </Button>
          <Button sx={{ mb: 6 }} onClick={reload}>
            {t('action:reload-page')}
          </Button>
        </Error>
      )

    default:
      return (
        <Error
          title="error:internal:title"
          text="error:internal:text"
          image={<Person />}
        >
          <Button onClick={goBack}>{t('action:go-to-previous-page')}</Button>
        </Error>
      )
  }
}

CaughtError.propTypes = {
  error: PropTypes.any,
}

export default CaughtError
